var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 7.5L15.2367 15.2556C15.1032 16.9923 13.655 18.3333 11.9132 18.3333H8.08677C6.34498 18.3333 4.89684 16.9923 4.76326 15.2557L4.16667 7.5M17.5 5.83333C15.3351 4.77832 12.7614 4.16667 10 4.16667C7.23862 4.16667 4.66493 4.77832 2.5 5.83333M8.33333 4.16667V3.33333C8.33333 2.41286 9.07953 1.66667 10 1.66667C10.9205 1.66667 11.6667 2.41286 11.6667 3.33333V4.16667M8.33333 9.16667V14.1667M11.6667 9.16667V14.1667",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f149f931ca01a64d65ceea8f9a795958.svg";
export { ForwardRef as ReactComponent };